import { createPortal } from "react-dom";
import Container from "../components/Container";
import Image from "../components/Image";
import loader from "../assets/images/wings_loader.gif";

interface IMainLoaderProps {
    fullHeight?: boolean;
    minHeight?: string;
}

export default function MainLoader({ fullHeight = true, minHeight }: IMainLoaderProps) {
    return (
        <Container
            center
            fullWidth
            fullHeight={fullHeight}
            className="my-progress-spinner absolute inset-0 bg-white"
            style={{ minHeight: minHeight }}
        >
            <Image src={loader} width={80} />
        </Container>
    );
}

/** Cobre o viewport inteiro (portal em document.body — evita recorte por transform/z-index do app). */
export function SessionLogoutOverlay({ message = "Encerrando sessão…" }: { message?: string }) {
    return createPortal(
        <div
            className="fixed inset-0 flex flex-col items-center justify-center gap-4 bg-white"
            style={{
                width: "100vw",
                height: "100vh",
                minHeight: "100vh",
                zIndex: 2147483647,
            }}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <div className="my-progress-spinner flex flex-col items-center justify-center gap-4">
                <Image src={loader} width={80} />
                <p className="text-gray-600 text-sm m-0 text-center px-4">{message}</p>
            </div>
        </div>,
        document.body
    );
}
